import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"

export default function PlayGate() {
  const { loading, loadError, isGameReady, retryInitialLoad } = useGuardiansPassport()
  const location = useLocation()
  const onOnboarding = location.pathname.startsWith("/play/onboarding")

  if (loading) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-3">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-guardians-accent border-t-transparent" />
        <p className="text-sm text-guardians-muted">Загрузка профиля…</p>
      </div>
    )
  }

  if (loadError === "offline") {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
        <p className="text-guardians-muted">Нет сети</p>
        <button
          type="button"
          className="rounded-xl bg-guardians-accent px-5 py-2 font-medium text-guardians-bg"
          onClick={retryInitialLoad}
        >
          Повторить
        </button>
      </div>
    )
  }

  if (!isGameReady && !onOnboarding) {
    return <Navigate to="/play/onboarding" replace />
  }

  if (isGameReady && onOnboarding && location.pathname === "/play/onboarding") {
    return <Navigate to="/play" replace />
  }

  return <Outlet />
}
